import { FileUpload } from './../../service/FileUpload/fileUpload';
import { Location } from '@angular/common';
import { FileUploadService } from './../../file-upload.service';
import { ContactUsService } from './../../service/contactUsService/contact-us.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent  {

phone:any;email:any;address:any;
contactUs:any=[];path:string='RESTAURANTDETAIL';currentUpload:any;selectedFile:any;
  constructor(private location: Location,private UploadService:FileUploadService,private apiService:ContactUsService) { 
    this.contactUs[0]={
      name:'',
      bannerImage:{url:''}
    }
    this.getContent();
  }
  deleteAboutImage(image)
  {
    console.log(image)
      this.UploadService.deleteUpload(image,this.path).then((res)=>
      {
        console.log('Previous Image Deleted');
        this.currentUpload=null;
      
          this.contactUs[0].bannerImage={}
      })
    
  }
  uploadSingle(event:any)
  {
    if(event.target.files && event.target.files[0])
    {
      this.selectedFile=event.target.files[0];
    this.currentUpload = new FileUpload(this.selectedFile);
    console.log(this.currentUpload);
    this.UploadService.pushUpload(this.currentUpload,this.path).then((res) => {
        this.contactUs[0].bannerImage=res
      console.log(res);
      console.log(this.UploadService.uploadPercentage);
      
    });
  }
  }
 add(a)
 {
    if(a=='email')
    {
this.contactUs[0].email.push(this.email)

    }
    else if(a=='address')
    {
      this.contactUs[0].address.push(this.address)

    }
    else if(a=='mobile')
    {
      this.contactUs[0].phoneNo.push(this.phone)
    }
 }
 delete(data,a)
 {
   console.log(a)
  if(a=='email')
  {
    this.contactUs[0].email=this.contactUs[0].email.filter(function(el){ return el != data; });
  

  }
  else if(a=='address')
  {
    this.contactUs[0].address=this.contactUs[0].address.filter(function(el){ return el != data; });


  }
  else if(a=='mobile')
  {
    this.contactUs[0].phoneNo=this.contactUs[0].phoneNo.filter(function(el){ return el != data; });
    
  }
 }
getContent()
{
this.apiService.getRestaurantDetails().then((res:any)=>
{
  this.contactUs=res;
  console.log(this.contactUs)
})
}
UpdateContent(id,content)
{
  this.apiService.EditRestaurantDetailsDetail(id,content).then((res)=>
  {
    location.reload();
  })
}
back()
{
  this.location.back();
}
}
